import { render } from "./CollapsibleList.vue?vue&type=template&id=679c94ae"
import script from "./CollapsibleList.vue?vue&type=script&lang=js"
export * from "./CollapsibleList.vue?vue&type=script&lang=js"

import "./CollapsibleList.vue?vue&type=style&index=0&id=679c94ae&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__